import client from '@stores/apollo'
import gql from 'graphql-tag'
import { IBookingImportFailed } from '@api'
import { BookingImportFailedFragment } from '@api/fragments'

export default function failed(id: string): Promise<{ failed: IBookingImportFailed[] | null }> {
  return client.gql.query({ query, variables: { id } }).then(
    ({
      data: {
        node: { failed },
      },
    }: {
      data: { node: { failed: IBookingImportFailed[] | null } }
    }) => ({ failed })
  )
}

const query = gql`
  query importFailed($id: ID!) {
    node(id: $id) {
      ... on BookingImport {
        failed {
          ...BookingImportFailedFragment
        }
      }
    }
  }
  ${BookingImportFailedFragment}
`
